<template>
  <div class="research-papers">
    <div class="head">
      <i class="iconfont icon--papers el-button--text"></i>{{item.name_cn}}
      <p class="operation pull-right">
        <template v-if="editing">
          <el-button type="text" @click="linkTo(item.name)">+ 添加新成果</el-button>
          <!-- 排序操作 -->
          <el-dropdown @command="handleSortCommand" :trigger="isMobile ? 'click' : 'hover'">
            <span class="el-dropdown-link el-button--text">
              {{text}}<i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="timeAsc">按获得时间升序</el-dropdown-item>
              <el-dropdown-item command="timeDesc">按获得时间降序</el-dropdown-item>
              <el-dropdown-item divided command="weightDesc">按重要程度降序</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown @command="handleCommand" :trigger="isMobile ? 'click' : 'hover'">
            <span class="el-dropdown-link el-button--text">
              <i class="iconfont icon--menu-dot"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="hideModule">隐藏模块</el-dropdown-item>
              <el-dropdown-item command="sortModule">模块排序</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </p>
    </div>
    <div class="detail">
      <div class="text">
        <!-- 默认显示10条 -->
        <ul>
          <template v-for="(item, sub) in (editing ? item.data : item.data.filter(n => parseInt(n.display_status) !== 0))">
            <template v-if="sub < 10">
              <li :class="{'status-hide' : item.display_status == 0}" :key="sub">
                <template v-if="editing">
                  <span v-if="item.display_status == 1" class="status status-show" @click="updateItem(index, sub, 0)">

                    <template v-if="isMobile">
                      <i class="iconfont icon--show"></i>
                    </template>
                    <template v-else>
                      <template v-if="sub === 0 && showTips">
                        <i class="iconfont icon--show"></i>
                      </template>
                      <template v-else>
                        <el-tooltip class="item" effect="dark" content="点此隐藏此成果" placement="left">
                          <i class="iconfont icon--show"></i>
                        </el-tooltip>
                      </template>
                    </template>

                    <template v-if="sub === 0">
                      <el-tooltip class="item" effect="dark" content="点击隐藏/显示此成果" :placement="isMobile ? 'top' : 'left'" v-model="showTips">
                        <i class="iconfont icon--show absolute"></i>
                      </el-tooltip>
                    </template>
                  </span>

                  <template v-else>
                    <template v-if="isMobile">
                      <span class="status status-hide" @click="updateItem(index, sub, 1)">
                        已隐藏<i class="iconfont icon--hide"></i>
                      </span>
                    </template>
                    <template v-else>
                      <el-tooltip class="item" effect="dark" content="点此显示此成果" placement="left">
                        <span class="status status-hide" @click="updateItem(index, sub, 1)">
                          已隐藏<i class="iconfont icon--hide"></i>
                        </span>
                      </el-tooltip>
                    </template>
                  </template>
                </template>
                <!-- 序号 -->
                <span class="serial-number">[{{sub + 1}}]</span>
                <!-- 共同作者 -->
                <span>
                  <template v-if="item.authors.length">
                    <template v-for="(author, index) in item.authors">
                      <template v-if="index < 3">
                        <template v-if="item.paper.language == 1">
                          <template v-if="index > 0">,</template>
                          {{author.realname || author.en_realname}}
                        </template>
                        <template v-else-if="item.paper.language == 2">
                          <template v-if="index > 0">,</template>
                          {{author.en_realname || author.realname}}
                        </template>
                      </template>
                      <template v-if="index == 3">
                        <template v-if="item.paper.language == 1">,等</template>
                        <template v-else-if="item.paper.language == 2">,et al</template>
                      </template>
                    </template>
                  </template>
                </span>
                <!-- 论文标题 -->
                <span>.{{item.title}}</span>
                <!-- 文献类型标志 -->
                <span>
                  <template v-if="item.paper.paper_type == '期刊论文'">
                    [J].
                  </template>
                  <template v-else-if="item.paper.paper_type == '会议论文集'">
                    [C].
                  </template>
                  <template v-else-if="item.paper.paper_type == '报纸'">
                    [N].
                  </template>
                  <template v-else-if="item.paper.paper_type == '学位论文'">
                    [D].
                  </template>
                </span>
                <!-- 期刊名 -->
                <span>{{item.paper.jurnal}}.</span>
                <!-- 发表年份 -->
                <span>{{item.paper.jurnal_puttime.split('-')[0]}}</span>
                <!-- 卷号 -->
                <span v-if="item.paper.batch">,{{item.paper.batch}}</span>
                <!-- 期号 -->
                <span v-if="item.paper.issue">({{item.paper.issue}})</span>
                <!-- 页码 -->
                <span v-if="item.paper.page_index">:{{item.paper.page_index}}</span>
              </li>
            </template>
          </template>
        </ul>
        <!-- 大于10条的部分 -->
        <ul v-show="showMore">
          <template v-for="(item, sub) in (editing ? item.data : item.data.filter(n => parseInt(n.display_status) !== 0))">
            <template v-if="sub > 9">
              <li :class="{'status-hide' : item.display_status == 0}" :key="sub">
                <template v-if="editing">

                  <span v-if="item.display_status == 1" class="status status-show" @click="updateItem(index, sub, 0)">

                    <template v-if="isMobile">
                      <i class="iconfont icon--show"></i>
                    </template>
                    <template v-else>
                      <el-tooltip class="item" effect="dark" content="点此隐藏此成果" placement="left">
                        <i class="iconfont icon--show"></i>
                      </el-tooltip>
                    </template>
                  </span>

                  <template v-else>
                    <template v-if="isMobile">
                      <span class="status status-hide" @click="updateItem(index, sub, 1)">
                        已隐藏<i class="iconfont icon--hide"></i>
                      </span>
                    </template>
                    <template v-else>
                      <el-tooltip class="item" effect="dark" content="点此显示此成果" placement="left">
                        <span class="status status-hide" @click="updateItem(index, sub, 1)">
                          已隐藏<i class="iconfont icon--hide"></i>
                        </span>
                      </el-tooltip>
                    </template>
                  </template>
                </template>
                <!-- 序号 -->
                <span class="serial-number">[{{sub + 1}}]</span>
                <!-- 共同作者 -->
                <span>
                  <template v-if="item.authors.length">
                    <template v-for="(author, index) in item.authors">
                      <template v-if="index < 3">
                        <template v-if="item.paper.language == 1">
                          <template v-if="index > 0">,</template>
                          {{author.realname || author.en_realname}}
                        </template>
                        <template v-else-if="item.paper.language == 2">
                          <template v-if="index > 0">,</template>
                          {{author.en_realname || author.realname}}
                        </template>
                      </template>
                      <template v-if="index == 3">
                        <template v-if="item.paper.language == 1">,等</template>
                        <template v-else-if="item.paper.language == 2">,et al</template>
                      </template>
                    </template>
                  </template>
                </span>
                <!-- 论文标题 -->
                <span>.{{item.title}}</span>
                <!-- 文献类型标志 -->
                <span>
                  <template v-if="item.paper.paper_type == '期刊论文'">
                    [J].
                  </template>
                  <template v-else-if="item.paper.paper_type == '会议论文集'">
                    [C].
                  </template>
                  <template v-else-if="item.paper.paper_type == '报纸'">
                    [N].
                  </template>
                  <template v-else-if="item.paper.paper_type == '学位论文'">
                    [D].
                  </template>
                </span>
                <!-- 期刊名 -->
                <span>{{item.paper.jurnal}}.</span>
                <!-- 发表年份 -->
                <span>{{item.paper.jurnal_puttime.split('-')[0]}}</span>
                <!-- 卷号 -->
                <span v-if="item.paper.batch">,{{item.paper.batch}}</span>
                <!-- 期号 -->
                <span v-if="item.paper.issue">({{item.paper.issue}})</span>
                <!-- 页码 -->
                <span v-if="item.paper.page_index">:{{item.paper.page_index}}</span>
              </li>
            </template>
          </template>
        </ul>
        <div class="show-more" v-if="!showMore && (editing ? item.data : item.data.filter(n => parseInt(n.display_status) !== 0)).length >= 10 && hasMore">
          <el-button :loading="loading" type="text" @click="showMoreItem">查看更多成果<i class="iconfont icon--arrow"></i></el-button>
        </div>
        <div class="hide-more" v-if="showMore && (editing ? item.data : item.data.filter(n => parseInt(n.display_status) !== 0)).length > 10 && hasMore">
          <el-button type="text" @click="hideMoreItem">收起<i class="iconfont icon--arrow-up"></i></el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DocsMixins from './docsMixins'
export default {
  mixins: [DocsMixins],
  props: {
    isFirstEditing: Number
  },
  data () {
    return {
      showTips: false
    }
  },
  created () {
    this.$nextTick(() => {
      if (this.isFirstEditing) {
        this.showTips = true
      }
    })
  },
  methods: {
    /**
     * [updateItem description]
     * @param  {[number]} index [模块的下标]
     * @param  {[number]} sub  [单个文件的下标]
     * @param  {[Boolean]} bool [隐藏 or 显示 (显示为1，隐藏为0)]
     * @return null
     */
    updateItem (index, sub, bool) {
      if (sub === 0) {
        this.showTips = false
      }
      this.$emit('updateItem', index, sub, bool)
    }
  },
  watch: {
    editing: function () {
      if (this.isMobile && this.isFirstEditing) {
        this.showTips = false
        this.$nextTick(function () {
          this.showTips = true
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Index/papers.vue